export default function getResource(label, vars=[]) {
    const resources = {
        service: 'Service',
        details: 'Details',
        selectedFeature: `Selected Feature: ${vars[0]}`,
        location: 'Location',
        confirmationNumber: 'Confirmation #'
    };

    return resources[label];
}
